/**
 * Created by Ivan on 09.07.2025
 */

cleverapps.override(cleverapps.EVENTS, {
    UNITS_SHOP_AVAILABLE: "ushop_available",
    UNITS_SHOP_FREE_PRODUCT: "ushop_buy_free",
    UNITS_SHOP_OPEN: "ushop_open",
    UNITS_SHOP_BUY: "ushop_buy",

    DRHOUSE_COLLECT: "drhouse_collect_",
    DRHOUSE_COLLECT_FIRST: "drhouse_collect_first"
});